import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions";
import axios from "../../axios";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Popover,
  PopoverBody,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import { IoCalendarClear, IoCalendarClearOutline } from "react-icons/io5";
import { BsCalendarPlus } from "react-icons/bs";
import ReactDatePicker, { setDefaultLocale } from "react-datepicker";
import { withRouter } from "react-router";
import parse from "react-html-parser";
import { sortBy } from "lodash";
import _debounce from "lodash/debounce";

function MonthlyGuidesModal({
  open,
  onClose,
  currentMonth,
  getTableForAnalytics,
  ...props
}) {
  const [filteredGuides, setfilteredGuides] = useState([]);
  const [minDate, setMinDate] = useState(moment().startOf("month"));
  const [maxDate, setMaxDate] = useState(moment().endOf("month"));

  const [searchVal, setSearchVal] = useState("");
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [dataLoading, setdataLoading] = useState(false);
  const [sortField, setSortField] = useState(""); // Stores the current field to sort by
  const [sortOrder, setSortOrder] = useState("asc"); // Stores the current sorting order
  const [descModal, setDescModal] = useState(null);
  const [minDateTemp, setMinDateTemp] = useState(moment().startOf("month"));
  const [maxDateTemp, setMaxDateTemp] = useState(moment().endOf("month"));

  // Sort function
  const handleSort = (field) => {
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);

    // Sort the data based on the field and order
    resultsToShow.sort((a, b) => {
      if (field === "name") {
        return newSortOrder === "asc"
          ? a.name.localeCompare(b.name)
          : b.name.localeCompare(a.name);
      } else {
        const dateA = moment(a[field]);
        const dateB = moment(b[field]);
        return newSortOrder === "asc" ? dateA - dateB : dateB - dateA;
      }
    });
  };

  // Function to render sorting arrows
  const renderSortingArrows = (field) => {
    if (sortField === field) {
      return (
        <span className="cursor-pointer">
          {sortOrder === "asc" ? "↑" : "↓"}
        </span>
      );
    }

    return <span className="cursor-pointer">↑</span>;
  };

  useEffect(() => {
    setdataLoading(true);
    handleApplyDateFilter(minDate, maxDate, searchVal);
  }, []);

  const handleSearchChange = (v) => {
    debounceFn(minDate, maxDate, v);
  };
  const handleSearchDeb = (mn, mx, v) => {
    handleApplyDateFilter(mn, mx, v);
  };
  const debounceFn = useCallback(_debounce(handleSearchDeb, 1000), []);

  const resultsToShow = filteredGuides;

  const handleShowAll = () => {
    setMaxDateTemp(moment().endOf("year"));
    setMinDateTemp(moment().startOf("year"));
    setMaxDate(moment().endOf("year"));
    setMinDate(moment().startOf("year"));
    setSearchVal("");
    axios
      .post(url.getDiversityCalendarGuides, {})
      .then((data) => {
        setdataLoading(false);
        setPopoverOpen(false);
        setfilteredGuides(
          sortBy(data.data, [(x) => moment(x.startDate).format("MM-DD")])
        );
      })
      .catch((err) => {
        console.log(err);
        setPopoverOpen(false);
      });
  };

  const handleApplyDateFilter = (mnDate, mxDate, search) => {
    setMaxDate(mxDate);
    setMinDate(mnDate);
    setSearchVal(search);
    setPopoverOpen(false);

    axios
      .post(url.getDiversityCalendarGuides, {
        search,
        filters: { eventDatesDC: [mnDate, mxDate] },
      })
      .then((data) => {
        setdataLoading(false);

        setfilteredGuides(
          sortBy(data.data, [(x) => moment(x.startDate).format("MM-DD")])
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const renderView = (item) => {
    let link = "";

    if (
      item.attachments &&
      Array.isArray(item.attachments) &&
      item.attachments[0]
    ) {
      link = item.attachments[0].url;
    } else if (item.attachment) {
      link = item.attachment;
    } else if (item.image) {
      link = item.image;
    }

    if (link) {
      return (
        <a className="link-text" href={link} target="_blank">
          (view)
        </a>
      );
    } else {
      return (
        <span>
          <span
            onClick={() => {
              setDescModal(item._id);
            }}
            id={`view_guide_${item._id}`}
            className="link-text"
          >
            (view)
          </span>
          <Modal isOpen={descModal == item._id}>
            <ModalHeader toggle={() => setDescModal(null)}>
              Description
            </ModalHeader>
            <ModalBody>{parse(item.description)}</ModalBody>
          </Modal>
        </span>
      );
    }
  };

  const tableUi = (
    <div className="mt-4">
      {dataLoading ? (
        <div className="text-center">Loading Guides....</div>
      ) : (
        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
          <Table bordered>
            <thead>
              <tr>
                <th onClick={() => handleSort("name")}>
                  Name {renderSortingArrows("name")}
                </th>
                <th onClick={() => handleSort("startDate")}>
                  Start Date {renderSortingArrows("startDate")}
                </th>
                <th onClick={() => handleSort("endDate")}>
                  End Date {renderSortingArrows("endDate")}
                </th>
              </tr>
            </thead>

            <tbody>
              {resultsToShow && resultsToShow.length ? (
                resultsToShow.map((item) => {
                  return (
                    <tr>
                      <td style={{ display: "flex" }}>
                        <span className="dc-name-column">{item.name}</span>{" "}
                        {renderView(item)}
                      </td>
                      <td>{moment(item.startDate).format("MMMM D")}</td>
                      <td>{moment(item.endDate).format("MMMM D")}</td>
                    </tr>
                  );
                })
              ) : (
                <div className="text-center">No Guides to show...</div>
              )}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );

  return (
    <div>
      {getTableForAnalytics ? (
        <div>{tableUi}</div>
      ) : (
        <Modal isOpen={open}>
          <ModalHeader toggle={onClose} className="diversity-calendar-modal-bg">
            <div
              onClick={() => {
                setPopoverOpen(true);
              }}
              className="cursor-pointer"
            >
              Guides for{" "}
              <span id="diversity_calendar_date_filter">
                {minDate && maxDate ? (
                  <span style={{ textDecoration: "underline" }}>
                    {" "}
                    {moment(minDate).format("MMMM D")} -{" "}
                    {moment(maxDate).format("MMMM D")}{" "}
                  </span>
                ) : (
                  <span style={{ textDecoration: "underline" }}>
                    {currentMonth}
                  </span>
                )}{" "}
                <span className="ml-2">
                  {" "}
                  <BsCalendarPlus size={"20px"} className="cursor-pointer" />
                  <span style={{ fontSize: "11px", fontWeight: "300" }}>
                    {" "}
                    (click to change month)
                  </span>
                </span>
              </span>
              <Popover
                target={"diversity_calendar_date_filter"}
                isOpen={popoverOpen}
                toggle={() => setPopoverOpen(false)}
                placement="bottom"
                className="trends-date-select"
              >
                <PopoverBody>
                  Choose filters
                  <div className="d-flex">
                    <ReactDatePicker
                      onChange={(v) => setMinDateTemp(moment(v).startOf("day"))}
                      id="selectFileDate"
                      placeholderText="Enter date"
                      className="input-custom-date form-control mr-2"
                      showYearDropdown
                      selected={minDateTemp ? moment(minDateTemp) : null}
                    />
                    to
                    <ReactDatePicker
                      onChange={(v) => setMaxDateTemp(moment(v).endOf("day"))}
                      id="selectFileDate"
                      placeholderText="Enter date"
                      className="input-custom-date form-control ml-2"
                      showYearDropdown
                      selected={maxDateTemp ? moment(maxDateTemp) : null}
                    />
                  </div>
                  <div className="mt-3">
                    <Button
                      color="primary"
                      onClick={() =>
                        handleApplyDateFilter(
                          minDateTemp,
                          maxDateTemp,
                          searchVal
                        )
                      }
                    >
                      Filter
                    </Button>

                    <Button onClick={handleShowAll} outline className="ml-2">
                      Show all
                    </Button>

                    <Button
                      onClick={() => setPopoverOpen(false)}
                      className="float-right"
                    >
                      Close
                    </Button>
                  </div>
                </PopoverBody>
              </Popover>
            </div>
          </ModalHeader>
          <ModalBody>
            <div>
              <Input
                placeholder="Search..."
                className="input-lower-border"
                onChange={(e) => handleSearchChange(e.target.value)}
              />
            </div>

            {tableUi}
          </ModalBody>
        </Modal>
      )}
    </div>
  );
}

export default withRouter(MonthlyGuidesModal);
